module.exports = __webpack_public_path__ + "static/neural-rendering-9426a8c169c8b05ed9970f29d6ba1a26.gif";